// src/api/projectAnalyticsService.ts
import api from './config';

export interface ProjectSummary {
  total_projects: number;
  by_status: Record<string, number>;
  by_priority: Record<string, number>;
  on_track: number;
  at_risk: number;
  delayed: number;
  completed: number;
  avg_completion_time: number | null;
  budget_stats: {
    total: number;
    avg: number;
  };
  task_stats?: {
    total_tasks: number;
    completed_tasks: number;
    completion_percentage: number;
    by_status: Record<string, number>;
    by_priority: Record<string, number>;
  };
}

export interface ChartData {
  data: any[];
  layout: any;
}

export const getProjectSummary = async (): Promise<ProjectSummary> => {
  try {
    // This would be replaced with a real API call
    // const response = await api.get('/api/analytics/projects/summary');
    // return response.data.data;
    
    // Mock data
    return {
      total_projects: 5,
      by_status: {
        'Not Started': 1,
        'In Progress': 2,
        'On Hold': 0,
        'Completed': 2
      },
      by_priority: {
        'Low': 1,
        'Medium': 2,
        'High': 2
      },
      on_track: 2,
      at_risk: 1,
      delayed: 0,
      completed: 2,
      avg_completion_time: 45.5,
      budget_stats: {
        total: 75000,
        avg: 15000
      },
      task_stats: {
        total_tasks: 15,
        completed_tasks: 8,
        completion_percentage: 53.3,
        by_status: {
          'To Do': 3,
          'In Progress': 4,
          'Done': 8
        },
        by_priority: {
          'Low': 2,
          'Medium': 8,
          'High': 5
        }
      }
    };
  } catch (error) {
    console.error('Error fetching project summary:', error);
    throw error;
  }
};

export const getProjectStatusChart = async (): Promise<ChartData> => {
  try {
    // This would be replaced with a real API call
    // const response = await api.get('/api/analytics/projects/charts/status');
    // return response.data.data;
    
    // Mock data
    return {
      data: [
        {
          type: 'pie',
          values: [1, 2, 0, 2],
          labels: ['Not Started', 'In Progress', 'On Hold', 'Completed'],
          marker: {
            colors: ['#ff9800', '#2196f3', '#f44336', '#4caf50']
          }
        }
      ],
      layout: {
        title: 'Projects by Status',
        height: 400,
        margin: { l: 50, r: 50, t: 80, b: 50 }
      }
    };
  } catch (error) {
    console.error('Error fetching project status chart:', error);
    throw error;
  }
};

export const getProjectGanttChart = async (): Promise<ChartData> => {
  try {
    // This would be replaced with a real API call
    // const response = await api.get('/api/analytics/projects/charts/gantt');
    // return response.data.data;
    
    // Mock data
    return {
      data: [
        {
          x: [
            ['2023-01-01', '2023-04-30'],
            ['2023-02-01', '2023-07-31'],
            ['2023-01-01', '2023-03-15']
          ],
          y: ['Website Redesign', 'Mobile App', 'Database Migration'],
          type: 'bar',
          orientation: 'h',
          marker: {
            color: ['#2196f3', '#ff9800', '#4caf50']
          }
        }
      ],
      layout: {
        title: 'Project Timeline',
        xaxis: {
          type: 'date'
        },
        height: 300,
        margin: { l: 150, r: 50, t: 80, b: 50 }
      }
    };
  } catch (error) {
    console.error('Error fetching project Gantt chart:', error);
    throw error;
  }
};

export const getTaskStatusChart = async (projectId: number): Promise<ChartData> => {
  try {
    // This would be replaced with a real API call
    // const response = await api.get(`/api/analytics/projects/${projectId}/tasks/chart`);
    // return response.data.data;
    
    // Mock data
    return {
      data: [
        {
          type: 'pie',
          values: [1, 1, 1],
          labels: ['To Do', 'In Progress', 'Done'],
          marker: {
            colors: ['#ff9800', '#2196f3', '#4caf50']
          }
        }
      ],
      layout: {
        title: 'Task Status Distribution',
        height: 350,
        margin: { l: 50, r: 50, t: 50, b: 50 }
      }
    };
  } catch (error) {
    console.error(`Error fetching task chart for project ${projectId}:`, error);
    throw error;
  }
};

export const getProjectReportPdfUrl = (projectId: number): string => {
  return `/api/analytics/projects/${projectId}/report/pdf`;
};
